import apiClient from "../authentication/utils/core/axios";

// Credibility API service (mirrors backend endpoints)
const CredibilityAPI = {
  // GET /credibility/{user_id}?soft=true|false
  fetchUserCredibility: async (userId, { soft = false } = {}) => {
    const response = await apiClient.get(`/credibility/${userId}`, {
      params: { soft },
      validateStatus: (s) => [200, 202, 404].includes(s),
    });

    if (response.status === 202) {
      // Placeholder enqueued; return payload + pending flag
      return { data: response.data, status: 202 };
    }
    if (response.status === 404) {
      throw new Error("Credibility not computed yet for this user");
    }
    if (response.status !== 200) {
      throw new Error("Failed to fetch credibility");
    }
    return { data: response.data, status: 200 };
  },

  // GET /credibility/{user_id}/history?limit=
  fetchUserHistory: async (userId, { limit = 50 } = {}) => {
    const res = await apiClient.get(`/credibility/${userId}/history`, { params: { limit } });
    if (res.status !== 200) throw new Error("Failed to fetch credibility history");
    return res.data;
  },

  // GET /credibility/leaderboard/top?limit=
  fetchLeaderboard: async ({ limit = 50 } = {}) => {
    const res = await apiClient.get(`/credibility/leaderboard/top`, { params: { limit } });
    if (res.status !== 200) throw new Error("Failed to fetch credibility leaderboard");
    return res.data;
  },

  // POST /credibility/{user_id}/recompute  (202)
  enqueueRecompute: async (userId) => {
    const res = await apiClient.post(`/credibility/${userId}/recompute`);
    if (res.status !== 202) throw new Error("Failed to enqueue recompute");
    return res.data; // { accepted, rejected }
  },

  // POST /credibility/{user_id}/recompute/sync  (admin/debug)
  recomputeSync: async (userId) => {
    const res = await apiClient.post(`/credibility/${userId}/recompute/sync`);
    if (res.status !== 200) throw new Error("Failed to recompute credibility (sync)");
    return res.data;
  },

  // POST /credibility/groups/{group_id}/credibility
  fetchGroupCredibility: async (groupId) => {
    const response = await apiClient.get(`/credibility/groups/${groupId}/credibility`);
    return response.data;
  },
};

export default CredibilityAPI;
